import { render, staticRenderFns } from "./AreaFilter.vue?vue&type=template&id=6d8f2746&"
import script from "./AreaFilter.ts?vue&type=script&lang=ts&"
export * from "./AreaFilter.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports